import {Component} from '@angular/core';

import 'font-awesome/css/font-awesome.css';
import '../style/bootstrap.min.css';
import '../style/price-range.css';
import '../style/app.scss';
import '../style/animate.css';
import '../style/main.scss';
import '../style/responsive.scss';
import 'ng2-toasty/style-default.css';

@Component({
  selector: 'my-app', // <my-app></my-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')]
})
export class AppComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts